import React, { Component } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, Image as ImageIcon, MoreVertical } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const COMBOS = [{
  name: '2X Collina burger + pomfrit + 2x Pepsi 💙',
  components: ['2x Collina Burger', '1x Pomfrit', '2x Pepsi 0.33'],
  individualPrice: '1,180 RSD',
  comboPrice: '790 RSD',
  savings: '390 RSD (33% off)',
  cost: '295 RSD',
  margin: '63%',
  sales: 58,
  active: true
}, {
  name: 'Family Deal — 4 burgers + 2 pomfrit + 4 drinks',
  components: ['4x Any burger', '2x Pomfrit', '4x Any drink'],
  individualPrice: '~3,200 RSD',
  comboPrice: '2,490 RSD',
  savings: '~710 RSD (22% off)',
  sales: 24,
  active: true
}];
export function Combos() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1268">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1269">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1270">
          Combos & Bundles
        </h1>
        <Button icon={<Plus size={16} data-id="element-1272" />} data-id="element-1271">Add Combo</Button>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1273" />

      <div className="space-y-4" data-id="element-1274">
        {COMBOS.map((combo, i) => <Card key={i} className="flex gap-4 p-4" data-id="element-1275">
            <div className="w-32 h-32 bg-white/5 rounded-lg flex items-center justify-center shrink-0" data-id="element-1276">
              <ImageIcon className="text-text-secondary" size={32} data-id="element-1277" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1278">
              <div className="flex justify-between items-start mb-4" data-id="element-1279">
                <h3 className="font-bold text-lg" data-id="element-1280">{combo.name}</h3>
                <div className="flex gap-2" data-id="element-1281">
                  <Button size="sm" variant="secondary" data-id="element-1282">
                    Edit
                  </Button>
                  <button className="p-2 hover:bg-white/10 rounded-lg text-text-secondary" data-id="element-1283">
                    <MoreVertical size={16} data-id="element-1284" />
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1285">
                <div data-id="element-1286">
                  <div className="text-xs text-text-secondary uppercase mb-2" data-id="element-1287">
                    Components
                  </div>
                  <ul className="space-y-1 text-sm list-disc list-inside" data-id="element-1288">
                    {combo.components.map((item, j) => <li key={j} data-id="element-1289">{item}</li>)}
                  </ul>
                </div>
                <div data-id="element-1290">
                  <div className="text-xs text-text-secondary uppercase mb-2" data-id="element-1291">
                    Pricing
                  </div>
                  <div className="space-y-1 text-sm" data-id="element-1292">
                    <div className="flex justify-between" data-id="element-1293">
                      <span className="text-text-secondary" data-id="element-1294">Individual:</span>
                      <span className="line-through text-text-muted" data-id="element-1295">
                        {combo.individualPrice}
                      </span>
                    </div>
                    <div className="flex justify-between font-bold" data-id="element-1296">
                      <span data-id="element-1297">Combo Price:</span>
                      <span className="text-accent-primary" data-id="element-1298">
                        {combo.comboPrice}
                      </span>
                    </div>
                    <div className="flex justify-between text-accent-success text-xs" data-id="element-1299">
                      <span data-id="element-1300">Savings:</span>
                      <span data-id="element-1301">{combo.savings}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-6 mt-4 pt-4 border-t border-white/5 text-sm" data-id="element-1302">
                {combo.cost && <>
                    <div className="text-text-secondary" data-id="element-1303">
                      Cost:{' '}
                      <span className="text-text-primary font-mono" data-id="element-1304">
                        {combo.cost}
                      </span>
                    </div>
                    <div className="text-text-secondary" data-id="element-1305">
                      Margin:{' '}
                      <span className="text-accent-success font-mono" data-id="element-1306">
                        {combo.margin}
                      </span>
                    </div>
                  </>}
                <div className="text-text-secondary" data-id="element-1307">
                  Sales:{' '}
                  <span className="text-text-primary font-bold" data-id="element-1308">
                    {combo.sales} this week
                  </span>
                </div>
                <div className="ml-auto flex items-center gap-2" data-id="element-1309">
                  <span className="text-xs text-text-secondary" data-id="element-1310">
                    📍 All locations
                  </span>
                  <span className="text-xs font-bold text-accent-success" data-id="element-1311">
                    ● Active
                  </span>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}